<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/COFG9d/images/e9780811866989_cover.jpg?1693567434113" alt="This image is the cover for the book Dad's Awesome Grilling Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dad's Awesome Grilling Book
      </h1>
      <p class="bookDescription body article font2">
        <b>Get fired up as the author of <i>Great Burgers</i> offers up sage grilling advice, witty reflections, and over one hundred tasty recipes.</b><br/><br/>Bob Sloan offers tasty recipes, sage advice, and witty reflections in this ultimate tribute to the glory of dads and their grills. He shows how easy it is to transform fresh ingredients into one hundred sizzling, delicious dishes like Honey-Glazed Spareribs, Lamb Burgers, and Grilled Sweet Potatoes. Even super-busy dads will run out of excuses with the section on 10 Super-Fast, Foolproof, Grilling Recipes—perfect for weeknight dinners. In addition to these family-impressing recipes, this essential grilling book serves up tips on keeping it simple when it comes to tools, how to choose between charcoal and gas, and why no one can ever have too many serving dishes.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Sloan, Antonis Achilleos
      </h2>
      
      <p class="authorDescription body article">Bob Sloan is the author of The Working Stiff Cookbook. His humor pieces and fiction have appeared in Playboy and Print magazines. He lives in New York City.Antonis Achilleos is a New York-based photographer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fa0e54b